var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 97.168 96.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.943,
    y1: 0.375,
    x2: 0.186,
    y2: 0.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42dee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0da1ba"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_3",
    d: "M71.228,25.859a3.791,3.791,0,0,0-3.264-2.607L47.349,21.38,39.2,2.306a3.8,3.8,0,0,0-6.984,0L24.07,21.38,3.451,23.252a3.8,3.8,0,0,0-2.157,6.641L16.878,43.558,12.283,63.8a3.8,3.8,0,0,0,5.648,4.1L35.708,57.27,53.481,67.9a3.8,3.8,0,0,0,5.651-4.1L54.538,43.558,70.121,29.893a3.8,3.8,0,0,0,1.107-4.035ZM36.05,57.065",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, 0, 38.896)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/star_3.b55f7ad1e5c70da3133a9dc63aad66c0.svg";
export { ForwardRef as ReactComponent };